import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';

import { TimesyncContext } from '../providers/TimesyncProvider/TimesyncProvider';
import BackendService from '../services/backendService';
import { Game } from '../services/backendService/types';
import { Template } from '../services/TemplateService/Template.type';
import { useQuery as useSearchQuery } from './useQuery';
function usePreviewGame(isFromDiscover?: boolean) {
  const { query } = useSearchQuery();
  const client = useQueryClient();
  const gameCacheKey = 'games';
  const isPreview = query.get('isPreview') === 'true';
  const { now } = useContext(TimesyncContext);

  const { mutate: createPreviewGame, isLoading: isLoadingPreview } = useMutation(
    async ({
      template,
      templateId,
      isDemoGame,
      activeTenantId,
    }: {
      template?: Template | null;
      templateId: string;
      isDemoGame?: boolean | null;
      activeTenantId?: string;
      onSuccessFunction: (data: Game) => void;
    }) => {
      if (template) {
        await BackendService.instance.template.templateAutoSave({
          id: templateId,
          modifiedAt: now(),
          slides: template.content.slides ? template.content.slides : [],
        });
      }
      return BackendService.instance.game.createPreviewGame(
        templateId,
        !!isDemoGame,
        !!isFromDiscover,
        activeTenantId,
      );
    },
    {
      onSettled: () => {
        client.invalidateQueries([gameCacheKey]);
      },
      onSuccess: (data, { onSuccessFunction }) => {
        onSuccessFunction(data);
      },
    },
  );

  return {
    createPreviewGame,
    isPreview,
    isLoadingPreview,
  };
}

export default usePreviewGame;
